import { Component, OnInit, WritableSignal, effect, signal } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { IonApp, IonRouterOutlet } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { LanguageChangeService } from 'src/app/services/language-change.service';

import { CommonLoadIndicatorControl } from './common-components/common-loader/common-load-indicator-control.component';
import {
  INotification,
  NotificationSystemService,
} from './common-components/services/common-notification-system.service';
import { Notification } from './common-components/services/common-notification.service';
import { AppConstants } from './constants/app-constants';
import { StorageConstants } from './constants/storage-constants';
import { AdminApprovalService } from './services/admin/admin-approval.service';
import { AttendantProfileService } from './services/attendant/attendant-profile.service';
import { CertificatesService } from './services/reference-data/certificates.service';
import { LanguagesService } from './services/reference-data/languages.service';
import { ServicesService } from './services/reference-data/services.service';
import { WorkPreferencesService } from './services/reference-data/work-preferences.service';
import { UserService } from './services/user/user.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss', '../assets/scss/_kendo-overrides.scss'],
  imports: [IonApp, IonRouterOutlet, CommonLoadIndicatorControl],
})
export class AppComponent implements OnInit {
  public load = {
    certs: signal(false),
    servs: signal(false),
    workPref: signal(false),
    langPref: signal(false),
    user: signal(false),
    adminApp: signal(false),
    attProf: signal(false),
  };

  notifications: WritableSignal<INotification> = signal<INotification>(undefined);

  constructor(
    private languageChangeService: LanguageChangeService,
    private userService: UserService,
    private certificateService: CertificatesService,
    private servicesService: ServicesService,
    private workPreferencesService: WorkPreferencesService,
    private languagesService: LanguagesService,
    private attendantProfileService: AttendantProfileService,
    private adminApprovalService: AdminApprovalService,
    private toastr: Notification,
    private notificationSystemService: NotificationSystemService,
    private analyticsService: AnalyticsService,
    private authService: MsalService
  ) {
    this.authService.handleRedirectObservable().subscribe();
    analyticsService.loadGoogleAnalytics();
    this.getSignals();
    effect(() => {
      this.getNotifications();
    });

    this.load.attProf = this.attendantProfileService.getLoad();
    this.load.adminApp = this.adminApprovalService.getLoad();
    this.load.user = this.userService.getLoad();
    this.load.certs = this.certificateService.getLoad();
    this.load.langPref = this.languagesService.getLoad();
    this.load.servs = this.servicesService.getLoad();
    this.load.workPref = this.workPreferencesService.getLoad();
  }

  ngOnInit() {
    const selectedlanguage = sessionStorage.getItem(StorageConstants.selectedlanguage);
    if (selectedlanguage) {
      this.languageChangeService.use(selectedlanguage);
    } else {
      this.languageChangeService.use(AppConstants.defaultLanguage);
    }
  }

  getSignals() {
    this.notifications = this.notificationSystemService.getNotification();
  }

  getNotifications() {
    if (this.notifications()) {
      switch (this.notifications()?.type) {
        case 'success':
          this.toastr.success(this.notifications()?.content, this.notifications()?.close);
          break;
        case 'error':
          this.toastr.error(this.notifications()?.content, this.notifications()?.close);
          break;
        case 'info':
          this.toastr.info(this.notifications()?.content, this.notifications()?.close);
          break;
        case 'warning':
          this.toastr.warning(this.notifications()?.content, this.notifications()?.close);
          break;
      }
    }
  }
}
